<!-- A sale or a house: each is its own card, laid out alike (photo, price, what, where). -->
<app-feed-sale-content *ngIf="sale; else accommodationCard" [sale]="sale" [ownerActions]="ownerActions"></app-feed-sale-content>

<ng-template #accommodationCard>
  <app-feed-accommodation-content *ngIf="accommodation" [accommodation]="accommodation" [ownerActions]="ownerActions"></app-feed-accommodation-content>
</ng-template>
